/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Bruksklasse {
    BK_6_28 = 'Bk_6_28',
    BK_8_32 = 'Bk_8_32',
    BK_T8_40 = 'Bk_T8_40',
    BK_T8_50 = 'Bk_T8_50',
    BK_10_42 = 'Bk_10_42',
    BK_10_50 = 'Bk_10_50',
}
